import { TYPES } from '@src/constants/leaderboard';
import { getCookie } from '@src/utils/cookie';
import moment from 'moment';

const getTopVoicesAndRankingListVoices = (
  voicesDetailData,
  activeTab,
  eventShow,
) => {
  const emergingBadges = eventShow?.prizes?.emerging?.map((prize) => ({
    rank: prize?.rank,
    badge: prize?.badge,
  }));
  const trendingBadges = eventShow?.prizes?.trending?.map((prize) => ({
    rank: prize?.rank,
    badge: prize?.badge,
  }));
  const badges = { emerging: emergingBadges, trending: trendingBadges };

  const voiceDataByTab =
    activeTab === TYPES[0].value
      ? voicesDetailData?.trending
      : voicesDetailData?.emerging;
  const prizesByTab =
    activeTab === TYPES[0].value
      ? eventShow?.prizes?.trending
      : eventShow?.prizes?.emerging;

  let topVoicesData = [
    {
      rank: 2,
      badge: badges[activeTab]?.find((badge) => badge.rank === 2)?.badge,
    },
    {
      rank: 1,
      badge: badges[activeTab]?.find((badge) => badge.rank === 1)?.badge,
    },
    {
      rank: 3,
      badge: badges[activeTab]?.find((badge) => badge.rank === 3)?.badge,
    },
  ];
  const voiceInList = [];
  voiceDataByTab?.forEach((voice) => {
    const voiceInPrizes = prizesByTab?.find(
      (prize) => prize.awardedVoice?.voiceCode === voice?.code,
    );
    if (voiceInPrizes) {
      topVoicesData = topVoicesData.map((item) => {
        if (item.rank === voiceInPrizes?.rank) {
          return {
            ...voice,
            ...item,
          };
        }
        return item;
      });
    } else {
      voiceInList.push({
        ...voice,
        stats: {
          ...voice?.stats,
          totalUsers: voice?.totalUsers ?? 0,
          totalCredits: voice?.totalCredits ?? 0,
        },
      });
    }
  });

  const missingCodeVoiceCount = topVoicesData.filter(
    (voice) => !voice.code,
  ).length;

  const shouldTrim = voiceInList?.length > 7;

  const trimmedVoices =
    shouldTrim && missingCodeVoiceCount > 0
      ? voiceInList.slice(0, -missingCodeVoiceCount)
      : voiceInList;

  return {
    topVoices: topVoicesData,
    rankingListVoices: trimmedVoices?.map((voice, index) => ({
      ...voice,
      badge: null,
      rank: index + 4,
    })),
  };
};

const dateInLastDays = (date, days = 7) => {
  if (!date) return false;
  const targetDate = moment(date);
  const now = moment();
  const sevenDaysAgo = moment().subtract(days, 'days');
  return targetDate.isBetween(sevenDaysAgo, now, null, '[]');
};

const shouldShowWeeklyHighlights = ({ userId }) => {
  const cookieName = `highlights-of-week-${userId}`;
  const getCurrentWeekId = () => {
    const week = moment().isoWeek();
    const year = moment().isoWeekYear();
    return `${year}-W${week}`;
  };

  const currentWeekId = getCurrentWeekId();
  const savedWeek = getCookie(cookieName);

  return savedWeek !== currentWeekId;
};

export {
  getTopVoicesAndRankingListVoices,
  dateInLastDays,
  shouldShowWeeklyHighlights,
};
